import React from 'react';
import { GenericFilterHeader } from '../../../components/requests/components/filter-columns/GenericFilterHeader';
import { PropagationStopper } from '../../../components/common';

interface SurveyStatusHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
    readonly filterOptions: string[];
}

export function SurveyStatusHeader({
    currentValue,
    onChange,
    filterOptions,
}: SurveyStatusHeaderProps) {
    return (
        <PropagationStopper>
            <GenericFilterHeader
                label="Status"
                filterOptions={['All', ...filterOptions]}
                currentValue={currentValue}
                onChange={onChange}
            />
        </PropagationStopper>
    );
}
